/**
 * @author NikolaV
 */
import './Tabs.scss';
import * as React from 'react';
import { cs } from '@shared/utils/utils-classname';


export class Tabs extends React.Component<{
    initialIndex?: number,
    index?: number, // controlled component
    onChange?: (index: number) => void
    lazyLoad?: boolean,
    displayValue?: 'flex' | 'block',
    flexDirection: any,
    hideSingleTab?: boolean // hide tabs when there is only one,
    children?: React.ReactNode
}> {
    static defaultProps = {
        displayValue: 'block',
        flexDirection: 'row'
    };

    state = {
        index: this.props.initialIndex || 0
    };

    render() {
        const safeChildren = React.Children.toArray(this.props.children).filter(Boolean);
        const index = this.props.hasOwnProperty('index') ? this.props.index : this.state.index;

        return (<>
                { (safeChildren.length > 1 || (safeChildren.length === 0 && !this.props.hideSingleTab)) &&
                    <nav className='class tabs-bar flex-row'>
                        { React.Children.map(safeChildren, (c, i) => (
                            <div className={cs('tabs-bar__tab', { active: index === i })} onClick={() => this.handleTabClick(i)}>
                                {(c as any).props.badgeColor &&
                                    <span style={{ display: 'inline-block', borderRadius: 5, width: 8, height: 8, marginRight: 5, background: (c as any).props.badgeColor }}/>
                                }
                                {(c as any).props.title}
                            </div>
                        ))}
                    </nav>
                }

                { this.props.lazyLoad ?
                    safeChildren[index]
                    :
                    React.Children.map(safeChildren, (c, i) => (
                        <div className='tab-pane of-h' style={{ display: i === index ? this.props.displayValue : 'none', flexDirection: this.props.flexDirection }}>
                        { safeChildren[i] }
                        </div>
                    ))
                }
            </>
        );
    }

    handleTabClick = (index: number) => {
        if (!this.props.hasOwnProperty('index')) {
            this.setState({ index });
        }
        if (typeof this.props.onChange === 'function') {
            this.props.onChange(index);
        }
    }
}

export class TabPane extends React.Component<{
    title: string | any,
    badgeColor?: string,
    children?: React.ReactNode
}> {
    render() {
        return (
            <>{this.props.children}</>
        );
    }
}
